import { IDictionary } from '@caslink/common-client/ng-app/dictionary/IDictionary';
import * as _ from 'lodash';

import {
    IControlInputReferenceType, IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor,
    IDeviceNode, IDynamicControlsSharedState, ISelectListControlInput
} from '../shared/models/device';

import { DeviceService } from '../shared/services/device.service';
import { RelationshipTypes } from '../shared/models/models';

// Visits an object matching the criteria for a value-listing control-input.
// If the object is visited, a reference to the corresponding value-listing
// is made to the node.
//
// NOTE:  This visitor does not add the control-input to the current grouping.
// Only the reference to the corresponding value-listing is established.
export class SelectListInputVisitor implements IDeviceItemVisitor {
    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;

    private _referenceLists: IDictionary<IControlInputReferenceType[]>;
    private sharedState: IDynamicControlsSharedState;

    // When visitor initializes, store references to the reference
    // lists that can be searched when object is visited.
    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        this.sharedState = sharedState;
        this.parseReferenceLists(rootNode);
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        if (propValue.fieldRelationship && propValue.fieldRelationship.relationshipType === RelationshipTypes.SelectList) {
            let listKey = propValue.fieldRelationship.relatedFieldId;
            return this._referenceLists[listKey] !== null;
        }

        return false;
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let optionInput = propValue as ISelectListControlInput;
        optionInput.$fieldName = this.sharedState.nextId();

        optionInput.$valueList = this.getReferenceList(
            propValue.fieldRelationship.relatedFieldId,
            optionInput);

        return null;
    }

    private parseReferenceLists(node: IDeviceNode ) {
        this._referenceLists = {};
        let selectListData: any = node['selectLists'] || {};

        for (var listDataProp in selectListData) {
            if (!selectListData.hasOwnProperty(listDataProp)) { continue; }

            let listData = this.sortListData(selectListData[listDataProp]);

            this._referenceLists[listDataProp.toUpperCase()] = listData.items;
        }
    }

    private getReferenceList(statePropId: string, optionInput: ISelectListControlInput) {

        let list = this._referenceLists[statePropId.toUpperCase()];

        // Determine if the set of list items should be a subset.
        var valueSet = optionInput.valueSet;

        if (valueSet) {
            return _.map(valueSet, v => {
                return _.find(list, {value: v});
            });
        }

        return list;
    }

    private sortListData(listData) {
        if (Array.isArray(listData.items) && listData.items.every(i => typeof i.displayOrder !== 'undefined')) {
            listData.items = _.sortBy(listData.items, (i => i.displayOrder));
        }

        return listData;
    }
}
